module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Add new choice template",
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "templateForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.templateForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Template name",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.templateForm.title),
      callback: function($$v) {
        _vm.$set(_vm.templateForm, "title", $$v)
      },
      expression: "templateForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.templateForm.description),
      callback: function($$v) {
        _vm.$set(_vm.templateForm, "description", $$v)
      },
      expression: "templateForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Keywords",
      "prop": "keywords"
    }
  }, [_c('el-input-tag', {
    model: {
      value: (_vm.templateForm.keywords),
      callback: function($$v) {
        _vm.$set(_vm.templateForm, "keywords", $$v)
      },
      expression: "templateForm.keywords"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select category",
      "filterable": ""
    },
    model: {
      value: (_vm.templateForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.templateForm, "categoryId", $$v)
      },
      expression: "templateForm.categoryId"
    }
  }, _vm._l((_vm.choiceCategoryList), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.title,
        "value": category.id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "icon": "el-icon-plus",
      "circle": "",
      "size": "small"
    },
    on: {
      "click": _vm.handleAddCategory
    }
  })], 1), _vm._v(" "), (_vm.me.is_staff) ? _c('div', [_c('el-divider'), _vm._v(" "), _c('h3', [_vm._v("Staff options")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "isGlobal"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Is global choice template",
      "disabled": !isNaN(_vm.templateForm.id)
    },
    model: {
      value: (_vm.templateForm.isGlobal),
      callback: function($$v) {
        _vm.$set(_vm.templateForm, "isGlobal", $$v)
      },
      expression: "templateForm.isGlobal"
    }
  }), _vm._v(" "), (!isNaN(_vm.templateForm.id)) ? _c('help-text', [_vm._v("(Disabled: this can only be set on new choice templates)")]) : _vm._e(), _vm._v(" "), _c('help-text', [_vm._v("Should this choice template be available to all companies (green template)")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('h4', [_vm._v("Choices")]), _vm._v(" "), _c('div', {
    staticClass: "choice-container"
  }, _vm._l((_vm.choiceTemplateDialogChoices), function(choice) {
    return _c('div', {
      key: choice.id,
      staticClass: "choice",
      class: _vm.choiceTemplateDialogIsScale ? _vm.choiceScaleClass(choice) : 'unpolarized'
    }, [_c('span', {
      staticClass: "choice-title"
    }, [_vm._v(_vm._s(choice.title))])])
  }), 0)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.templateForm.id ? 'Save' : 'Create'))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-331b4198","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/dialogs/ChoiceTemplateSaveDialog.vue
// module id = 3208
// module chunks = 3